import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { useHook } from '../../hook'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { FilterLayout } from '../Filter'
import { useMemo } from 'react'
import { ENewTumRegisterStatus } from '../../type'
import BaseText from 'app/components/common/BaseText'

interface ApproveUnionMembersTableProps {
  status: ENewTumRegisterStatus
}

const ApproveUnionMembersTable = ({
  status,
}: ApproveUnionMembersTableProps) => {
  const {
    columns,
    pagination,
    filter,
    onChangeFilter,
    handleChangePagination,
    isLoading,
    data,
    isPermissionUpdate,
  } = useHook({ status })

  const _columns = useMemo(() => {
    return columns.filter(item =>
      status !== ENewTumRegisterStatus.WAITING ? item.key !== 'id' : item,
    )
  }, [status, columns, isPermissionUpdate])

  return (
    <BaseSpace size={0}>
      <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />
      <BaseTableManagement
        columns={_columns}
        dataSource={data}
        pagination={{
          ...pagination,
          total: pagination.total,
          showTotal: total => (
            <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
          ),
          showSizeChanger: true,
        }}
        loading={isLoading}
        onChange={handleChangePagination}
        rowClassName="row-overwrite-style"
      />
    </BaseSpace>
  )
}

export default ApproveUnionMembersTable
